import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Persona: an archetype representing a group of stakeholders who share similar roles, needs, and experiences of a change.',
    name: 'Personas',
    partialId: PartialId.Standard.create('personas'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
